/** Normalize booking fields from API (snake_case / alternate keys). */

export function clientLabel(b) {
  return b.clientName || b.client_name || b.customer_name || b.user_name || '—';
}

export function serviceLabel(b) {
  return b.service || b.service_name || b.service_title || b.package_name || '—';
}

export function dateLabel(b) {
  return b.date || b.booking_date || b.scheduled_date || b.appointment_date || '';
}

export function timeLabel(b) {
  return b.time || b.booking_time || b.start_time || '';
}

export function statusLabel(b) {
  const s = b.status || b.booking_status || '';
  return s ? String(s).toLowerCase() : '';
}

export function notesLabel(b) {
  return b.notes || b.note || b.special_notes || '';
}

export function bookingReferenceLabel(b) {
  return b.booking_reference || b.reference || '';
}

export function salonLabel(b) {
  return b.salon_name || b.salonName || '';
}

export function paymentStatusLabel(b) {
  return b.payment_status || '';
}

export function paymentModeLabel(b) {
  return b.payment_mode || '';
}

export function totalCostLabel(b) {
  return b.total_cost ?? b.totalAmount ?? b.total ?? '';
}
